document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    if(document.querySelector('.top-content-slider')){
        let sliderTopContent = new Swiper('.top-content-slider',{
            loop: true,
            speed: 700,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                nextEl: '.swiper-prev',
                prevEl: '.swiper-next'
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            }
        })

        document.querySelector('.js-active-play').addEventListener('click', () => {
            if (sliderTopContent.autoplay.running) {
                sliderTopContent.autoplay.stop();
            } else {
                sliderTopContent.autoplay.start();
            }
            document.querySelector('.js-active-play').classList.toggle('play');
        });
    }

    function updateAriaLabels() {
    const nextBtn = document.querySelector('.slider-next');
    const prevBtn = document.querySelector('.slider-prev');

    if (nextBtn) {
        nextBtn.setAttribute('aria-label', 'NXT - Next Slide');
    }

    if (prevBtn) {
        prevBtn.setAttribute('aria-label', 'PRV - Prev Slide');
    }
}

    let quadSlider = new Swiper('.slider__slider', {
        loop: true,
        speed: 700,
        effect: 'fade',
        allowTouchMove: false,
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.slider-prev',
            nextEl: '.slider-next'
        },
        on: {
            init: function () {
                const nextImg = document.querySelector('.swiper-slide-next .slider__image img');
                const rightImg = document.querySelector('.slider__right img');

                if (nextImg && rightImg) {
                    rightImg.setAttribute('src', nextImg.getAttribute('src'));
                    rightImg.setAttribute('alt', nextImg.getAttribute('alt'));
                }

                setTimeout(updateAriaLabels, 0);
            },
            slideChange: function () {
                updateAriaLabels();
            }
        }
    });

    document.querySelectorAll('.slider-prev, .slider-next').forEach((arrow)=>{
        arrow.addEventListener('click', ()=>{
            let src = document.querySelector('.swiper-slide-next .slider__image img').getAttribute('src');
            document.querySelector('.slider__right').classList.remove('show');
            setTimeout(() => {
                document.querySelector('.slider__right').classList.add('show');
                document.querySelector('.slider__right img').setAttribute('src', src);
            }, 1);
        });
    });

    let singleSlider = new Swiper('.quad-slider__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.quad-slider-prev',
            nextEl: '.quad-slider-next'
        }
    });

    let cardsTwo = new Swiper('.cards__slider-two',{
        speed: 800,
        slidesPerView: 1,
        loop: true,
        spaceBetween: 10,
        pagination: {
            el: '.cards-pagination',
            clickable: true
        },
        breakpoints: {
            650: {
                slidesPerView: 2,
                spaceBetween: 15,
                loop: false,
                pagination: false
            }
        }

    });
    let cardsThree = new Swiper('.cards__slider-three',{
        speed: 800,
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
            el: '.cards-pagination',
            clickable: true
        },
        breakpoints: {
            650: {
                slidesPerView: 2,
                spaceBetween: 15
            },
            1024: {
                slidesPerView: 3,
                spaceBetween: 0,
                loop: false
            }
        }
    });

    let quadReviews = new Swiper('.reviews__slider',{
        speed: 1000,
        loop: true,
        spaceBetween: 40,
        navigation: {
            prevEl: '.reviews-prev',
            nextEl: '.reviews-next',
        }
    });


    let sliderLeft = new Swiper('.gallery-quad__slider-left',{
        loop: true,
        speed: 800,
        slidesPerView: 1,
        allowTouchMove: false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        }
    });

    let sliderCenter = new Swiper('.gallery-quad__slider-center',{
        loop: true,
        speed: 800,
        slidesPerView: 1,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.gallery-arrow-prev',
            nextEl: '.gallery-arrow-next'
        },
        pagination: {
            el: '.gallery-center-pagination',
            clickable: true
        }
    });

    let sliderRight = new Swiper('.gallery-quad__slider-right',{
        loop: true,
        speed: 800,
        slidesPerView: 1,
        allowTouchMove: false,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        }
    });

    sliderCenter.controller.control = [sliderLeft,sliderRight];

    let roomSlider = new Swiper('.room-featured__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.room-featured-prev',
            nextEl: '.room-featured-next'
        }
    });
});